import {
  EditablePreview,
  useColorModeValue,
  IconButton,
  Input,
  useEditableControls,
  ButtonGroup,
  Editable,
  Tooltip,
  EditableInput,
  Skeleton,
  Text,
  Box
} from '@chakra-ui/react'
import { CheckIcon, CloseIcon } from '@chakra-ui/icons'
import { ChangeEventHandler } from 'react'

type InfoRowEditableProps = {
  title: string;
  value: string;
  isLoading?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>
};

export const InfoRowEditable = ({ title, value, isLoading, onChange }: InfoRowEditableProps) => {
  const titleColor = useColorModeValue('gray.900', 'white')
  const textColor = useColorModeValue('gray.600', 'gray.50')

  function EditableControls() {
    const {
      isEditing,
      getSubmitButtonProps,
      getCancelButtonProps,
    } = useEditableControls()

    return isEditing ? (
      <ButtonGroup justifyContent='end' size='sm' w='full' spacing={2} mt={2}>
        <IconButton aria-label='submit' icon={<CheckIcon />} {...getSubmitButtonProps()} />
        <IconButton
          aria-label='close'
          icon={<CloseIcon boxSize={3} />}
          {...getCancelButtonProps()}
        />
      </ButtonGroup>
    ) : null
  }

  return (
    <Box flexGrow={"1"}>
      <Text fontSize="1.1rem" fontWeight={'bold'} color={titleColor}>{title}</Text>
      <Skeleton minHeight="20px" isLoaded={!isLoading}>
        <Editable
          defaultValue={value}
          isPreviewFocusable={true}
          selectAllOnFocus={false}
        >
          <Tooltip label='Clique para Editar' shouldWrapChildren={true}>
            <EditablePreview
              py={1}
              px={1}
              cursor={'pointer'}
              color={textColor}
              _hover={{
                background: useColorModeValue('gray.100', 'gray.700'),
              }}
            />
          </Tooltip>
          <Input py={2} px={4} as={EditableInput} value={value} onChange={onChange} />
          <EditableControls />
        </Editable>
      </Skeleton>
    </Box>
  )
} 